export function setSubMenuWidth() {
    if (document.querySelector('.loominguraamatukogu')) {
      return; // no width for loominguraamatukogu
    }

    const windowWidth = window.innerWidth;
    const subMenuWrap = document.querySelector('.sub-menu-wrap');

    if (subMenuWrap) {
        subMenuWrap.style.width = (windowWidth + 900) + 'px';
    }
}

export function toggleMobileSubMenu() {
    document.querySelectorAll('li.menu-item-has-children').forEach(function (menuLink) {
      menuLink.addEventListener('click', function (event) {
        const subMenuWrap = this.querySelector('.sub-menu-wrap');
        if (subMenuWrap) {
          const subMenu = subMenuWrap.querySelector('.sub-menu');
          if (subMenu) {
            subMenu.classList.toggle('active');
          }
        }
  
        this.classList.toggle('rotated-icon');
      });
    });
}
  
  
  